import { create } from 'zustand';

export const useExplicitConsentReasonStore = create((set) => ({
  // State
  reasons: [],
  selectedReason: null,
  loading: false,
  error: null,
  success: null,
  uniqueValues: {},
  paginationData: {
    currentPage: 1,
    totalPages: 0,
    totalItems: 0,
    itemsPerPage: 10,
    hasNextPage: false,
    hasPreviousPage: false,
  },

  // Table state
  searchParams: {
    searchTerm: '',
    sortBy: '',
    sortDirection: 'asc',
  },
  columnFilters: {},

  // Actions
  setReasons: (reasons) => set({ reasons }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  setSuccess: (success) => set({ success }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),
  setPaginationData: (paginationData) => set({ paginationData }),

  setSearchTerm: (searchTerm) =>
    set((state) => ({
      searchParams: { ...state.searchParams, searchTerm, page: 1 }
    })),

  setSorting: (sortBy, sortDirection) =>
    set((state) => ({
      searchParams: { ...state.searchParams, sortBy, sortDirection, page: 1 }
    })),

  setColumnFilters: (columnFilters) => set({ columnFilters }),

  setCurrentPage: (page) =>
    set((state) => ({
      paginationData: { ...state.paginationData, currentPage: page }
    })),

  setPageSize: (pageSize) =>
    set((state) => ({
      paginationData: { ...state.paginationData, itemsPerPage: pageSize, currentPage: 1 }
    })),

  clearMessages: () => set({ error: null, success: null }),
  clearError: () => set({ error: null }),

  // Form State
  isFormOpen: false,
  isEditMode: false,
  formData: { name: '', description: '' },

  openForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    formData: { name: '', description: '' },
    error: null,
    success: null
  }),

  // Alias for compatibility
  openCreateForm: () => set({
    isFormOpen: true,
    isEditMode: false,
    formData: { name: '', description: '' },
    error: null,
    success: null
  }),

  openEditForm: (reason) => set({
    isFormOpen: true,
    isEditMode: true,
    formData: {
      name: reason.name || reason.reason || '',
      description: reason.description || ''
    },
    selectedReason: reason,
    error: null,
    success: null
  }),

  closeForm: () => set({
    isFormOpen: false,
    isEditMode: false,
    formData: { name: '', description: '' },
    selectedReason: null,
    error: null,
    success: null
  }),

  // Delete Dialog State
  isDeleteDialogOpen: false,
  reasonToDelete: null,

  openDeleteDialog: (reason) => set({
    isDeleteDialogOpen: true,
    reasonToDelete: reason
  }),

  closeDeleteDialog: () => set({
    isDeleteDialogOpen: false,
    reasonToDelete: null
  }),





  // Reset
  reset: () => set({
    reasons: [],
    loading: false,
    error: null,
    success: null,
    uniqueValues: {},
    paginationData: {
      currentPage: 1,
      totalPages: 0,
      totalItems: 0,
      itemsPerPage: 10,
      hasNextPage: false,
      hasPreviousPage: false,
    },
    searchParams: {
      searchTerm: '',
      sortBy: '',
      sortDirection: 'asc',
    },
    columnFilters: {}
  })
}));

export default useExplicitConsentReasonStore;
